enum EventFlowStep {
    ONE_MINUTE = 1,
    FIVE_MINUTES = 5,
    TEN_MINUTES = 10,
    FIFTEEN_MINUTES = 15,
    THIRTY_MINUTES = 30,
    SIXTY_MINUTES = 60,
}

export default EventFlowStep;
